export default {
    name: "AdminController",

    data() {
        return {
            menu: [
                {
                    title: "Users",
                    route: "admin.users.index",
                    icon: "mdi-account",
                    permission: true,
                },
                {
                    title: "Freelancers",
                    route: "admin.freelancers.index",
                    icon: "mdi-account-group",
                    permission: "staffAdminFreelancers",
                },
                {
                    title: "Logistics",
                    route: "admin.logistics.index",
                    icon: "mdi-clipboard-text",
                    permission: "staffAdminLogistics",
                },
                {
                    title: "Expenses",
                    route: "admin.expenses.index",
                    icon: "mdi-cash",
                    permission: "staffAdminExpenses",
                },
                {
                    title: "Timesheets",
                    route: "admin.timesheets.index",
                    icon: "mdi-table",
                    permission: "staffAdminTimesheets",
                },
                {
                    title: "Holidays",
                    route: "admin.holidays.index",
                    icon: "mdi-calendar-range",
                    permission: "staffAdminHolidays",
                },
                {
                    title: "Training",
                    route: "admin.training.modules.index",
                    icon: "mdi-school",
                    permission: "staffAdminTraining",
                },
                {
                    title: "Vehicles",
                    route: "admin.vehicles.index",
                    icon: "mdi-car-estate",
                    id: "vehicles",
                    permission: "staffAdminVehicles",
                },
                {
                    title: "Permissions",
                    route: "admin.permissions.index",
                    icon: "mdi-lock-open",
                    permission: false,
                },
                {
                    title: "Categories",
                    route: "admin.categories.index",
                    icon: "mdi-view-module",
                    permission: true,
                },
                {
                    title: "Announcements",
                    route: "admin.announcements.index",
                    icon: "mdi-bullhorn-outline",
                    permission: "staffAdminAnnouncements",
                },
                {
                    title: "URL Shortener",
                    icon: "mdi-at",
                    route: "admin.url-shortener.index",
                    permission: "staffAdminUrlShortener",
                },
            ],
        };
    },
    mounted() {
        this.generateMenu();
        this.$root.store.sideMenuTitle = "Admin";
    },

    methods: {
        generateMenu() {
            let menu = [];

            if (this.$page.props.auth.user.is_super_admin) {
                this.$root.store.sideMenu = this.menu;
                return;
            }

            _.each(this.menu, (menuItem) => {
                if (menuItem.permission === true) {
                    menu.push(menuItem);
                    return true;
                }

                if (menuItem.permission === false) {
                    return true;
                }

                //Check permission
                let find = _.find(
                    this.$page.props.auth.user.permissions,
                    (permission) => {
                        return permission === menuItem.permission;
                    }
                );

                if (find !== undefined) {
                    menu.push(menuItem);
                }
            });

            this.$root.store.sideMenu = menu;
        },
    },
};
